import React from 'react';
import { Image } from '@lt/components';
import styles from './HeaderAvatarMenuItem.module.css';

const HeaderAvatarMenuItem = ({ clientAvatar }) => {
  const avatarPath = clientAvatar;
  const fallback = 'https://level.travel/avatars/default.webp';

  return (
    <Image
      alt="avatar"
      src={avatarPath}
      className={styles.avatarImage}
      fallback={fallback}
    />
  );
};

export default HeaderAvatarMenuItem;
